/* video-poster-alt-shim.js
 * Shopify's `video_tag` Liquid filter inserts an <img> poster inside <video>
 * elements but does NOT propagate the `alt:` argument to that inner <img>.
 * This shim fills `alt` on those posters at runtime so screen readers and
 * Lighthouse can see them. Source of truth (in order): the video file's own
 * `alt` attribute (data-alt on the figure), nearby section heading, then a
 * generic site-name fallback.
 */
(function () {
  function fillAlts() {
    var imgs = document.querySelectorAll('figure.lazy-video video > img, .slideshow__video video > img, .media-with-text__media-wrapper video > img');
    var fallback = (document.querySelector('meta[property="og:site_name"]') || {}).content || 'Meera Capsule';
    imgs.forEach(function (img) {
      if (img.hasAttribute('alt') && img.getAttribute('alt').trim() !== '') return;
      var fig = img.closest('figure, .slideshow__video, .media-with-text__media-wrapper');
      var label =
        (fig && fig.getAttribute('aria-label')) ||
        (fig && fig.getAttribute('data-alt')) ||
        (fig && fig.querySelector('[data-video-alt]') && fig.querySelector('[data-video-alt]').getAttribute('data-video-alt')) ||
        fallback;
      img.setAttribute('alt', label);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillAlts);
  } else {
    fillAlts();
  }
  // Also re-run after a tick to catch lazy-injected videos
  setTimeout(fillAlts, 1500);
  // And on Shopify section editor re-renders
  document.addEventListener('shopify:section:load', fillAlts);
})();
